import { render, staticRenderFns } from "./Tentative.vue?vue&type=template&id=1f192fa4&scoped=true&"
import script from "./Tentative.vue?vue&type=script&lang=js&"
export * from "./Tentative.vue?vue&type=script&lang=js&"
import style0 from "./Tentative.vue?vue&type=style&index=0&id=1f192fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f192fa4",
  null
  
)

export default component.exports